import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
// import stylesheet, { directions } from 'src/Constants/stylesheet';
import Image from './Image';
import responsive from 'src/Constants/responsive';
import { Language } from 'src/_helpers/Languages';
import * as classNames from 'classnames';
import spacing from 'src/Constants/spacing';

export type ListItemProps = {
    project: ListItemDto,
    parentUID: string,
    onMouseEnter?: (legend: string) => void;
    onMouseLeave?: () => void;
};

const styles = {
    ListItem: {
        boxSizing: 'border-box',
        [responsive.Mobile]: {
            width: '100%',
            paddingBottom: spacing.Gutter.Mobile
        },
        [responsive.MobileHorizontal]: {
            width: '50%',
            marginBottom: spacing.Gutter.Mobile,
            '&:last-child': {
                marginBottom: 49
            }
        },
        [responsive.Laptop]: {
            width: '25%'
        },
        [responsive.Desktop]: {
            width: '20%'
        }
    },
    ListItemInner: {
        position: 'relative',
        [responsive.AfterMobile]: {
            paddingBottom: '100%'
        }
    },
    Figure: {
        [responsive.Mobile]: {
            // paddingBottom: spacing.Gutter.Mobile,
        },
        [responsive.AfterMobile]: {
            position: 'absolute',
            top: spacing.Gutter.Desktop / 2,
            left: spacing.Gutter.Desktop / 2,
            right: spacing.Gutter.Desktop / 2,
            bottom: spacing.Gutter.Desktop / 2
        }
    },
    Link: {
        [responsive.Mobile]: {
            position: 'relative',
            display: 'block',
            width: '100%',
            maxHeight: `calc(100vw - ${spacing.Gutter.Mobile * 2}px)`
        },
        [responsive.AfterMobile]: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        }

    },
    SquareLink: {
        [responsive.Mobile]: {
            position: 'relative',
            display: 'block',
            width: '100%',
            maxHeight: `calc(100vw - ${spacing.Gutter.Mobile * 2}px)`
        },
        [responsive.AfterMobile]: {
            '&': {
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '83%',
                height: '83%',
                transform: 'translate(-50%, -50%)'
            }
        }
    },
    Image: {
        [responsive.Mobile]: {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'bottom left',
            maxHeight: `calc(100vw - ${spacing.Gutter.Mobile * 2}px)`
        },
        [responsive.AfterMobile]: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            '$SquareLink &': {
                overflow: 'hidden',
                objectFit: 'cover',
            },
        }
    },
}
type Props =
    ListItemProps &
    StyledComponentProps<keyof typeof styles>;

class ListItem extends React.PureComponent<Props> {
    public render() {
        const {
            classes,
            project: { PreviewImage, PreviewText, UID },
            onMouseEnter,
            onMouseLeave,
            parentUID } = this.props;

        return (
            <div
                className={classes!.ListItem}
                data-item=""
            >
                <div className={classes!.ListItemInner}>
                    <figure
                        className={classNames(classes!.Figure)}
                        onMouseEnter={() => {
                            if (onMouseEnter !== undefined) { onMouseEnter(PreviewText) }
                        }}
                        onMouseLeave={() => {
                            if (onMouseLeave !== undefined) { onMouseLeave() }
                        }}
                    >
                        <a
                            className={this._isSquare(PreviewImage) ? classes!.SquareLink : classes!.Link}
                            href={`/${Language}/${parentUID}/${UID}`}
                        >
                            <Image
                                className={classes!.Image}
                                pictureRef={PreviewImage}
                                // tslint:disable-next-line:max-line-length
                                sizes="(max-width: 600px) 100vw, (min-width: 601px) and (max-width: 1200) 25vw, (min-width: 1201px) 25vw"
                            />
                        </a>
                    </figure>
                </div>
            </div>
        );
    }

    private _isSquare(image: PictureRef) {
        if (image === null) { return; }
        
        const { Width, Height } = image;
        const percentValue = (5 / 6) * 100;

        if (Width === Height) { return true }

        // Horizontal
        if (Width > Height) {
            if (Height > (Width * percentValue / 100)) {
                return true
            } else {
                return false
            }
        }

        // Vertical
        if (Width > (Height * percentValue / 100)) {
            return true
        } else {
            return false
        }
    }
}

export default withStyles(styles)(ListItem);


// WEBPACK FOOTER //
// ./src/Components/ListItem.tsx